export interface ProviderInsuranceSupport {
  insuranceCompany: InsuranceCompany;
}


export interface InsuranceCompany {
  createdAt: string;
  id: string;
  logo: string;
  name: string;
  shortName: string;
  updatedAt: string;
  url: string;
  key: string;
  order?: number;
  available?: boolean;
  metaGrouping?: InsuranceMetaGrouping;
}

export const enum InsuranceMetaGrouping {
  medicare = 'medicare',
  medicaid = 'medicaid',
}
